import Vue from 'vue';
import moment from 'moment';

Vue.filter('moment', (v, d) => {
  if (typeof v.toDate === 'function') {
    v = v.toDate();
  }
  return moment.utc(v).local().format(d);
});
